import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, Text } from '@mantine/core';
import { LanguageSelect } from '@/components/language-select';
import TimezoneSelect from '@/components/TImezoneSelect';
import { useProfileLocaleTimezone } from './useProfileLocaleTimezone';
import classes from './locale.module.css';

export const ProfileLocale = () => {
  const { t } = useTranslation();
  const { form, isLoading, handleSave } = useProfileLocaleTimezone();

  return (
    <form onSubmit={form.onSubmit(handleSave)}>
      <div className={classes.wrapper}>
        <Text className={classes.mainTitle}>{t('profile.locale')}</Text>

        {/* Язык */}
        <div className={classes.section}>
          <Text className={classes.title}>{t('profile.language')}</Text>
          <LanguageSelect
            label={t('profile.localeInfo')}
            value={form.getInputProps('language').value}
            {...form.getInputProps('language')}
          />
        </div>

        {/* Часовой пояс */}
        <div className={classes.section}>
          <Text className={classes.title}>{t('profile.timeZone')}</Text>
          <TimezoneSelect
            label={t('profile.timezoneInfo')}
            value={form.getInputProps('mainTimezone').value}
            {...form.getInputProps('mainTimezone')}
          />
        </div>

        {/* Дополнительный часовой пояс */}
        <div className={classes.section}>
          <Checkbox
            styles={{ label: { cursor: 'pointer' }, labelWrapper: { width: 'auto !important' } }}
            fz="14px"
            label={t('profile.additionalTimezone')}
            mb={12}
            {...form.getInputProps('checkbox', { type: 'checkbox' })}
          />

          {form.getInputProps('checkbox').value && (
            <>
              <Text className={classes.title}>{t('profile.dopTimeZone')}</Text>
              <TimezoneSelect
                label={t('profile.additionalTimezoneDescription')}
                value={form.getInputProps('secondTimezone').value}
                {...form.getInputProps('secondTimezone')}
              />
            </>
          )}
        </div>

        {/* Кнопка сохранения */}
        <Button w={200} loading={isLoading} h={36} type="submit" disabled={!form.isDirty()}>
          {t('save')}
        </Button>
      </div>
    </form>
  );
};
